export default __webpack_public_path__ + "static/media/Group 3196@2x.b41cbdb5.png";